import { useContext } from 'react';
import { BIMContext } from 'providers/bim-provider';
import { ContentWrapper, Textarea } from 'components/generic';
import { alertMailConfig } from 'config';
import './style.scss';

const AlertMessage = () => {
	const context = useContext(BIMContext);
	const { alertState, setAlertState, createObj, setCreateObj } = context;

	// handle alert textarea
	const handleAlertsMail = e => {
		setCreateObj(prevState => ({ ...prevState, bfm_alerts: { ...prevState.bfm_alerts, [alertState]: [e] } }));
	};

	// tablist for alerts
	const alertTabs = (
		<ul className='alert__message'>
			{alertMailConfig?.map((el, i) => (
				<li key={i}>
					<span className={alertState === el?.key ? 'alert__message--active' : 'alert__message--inactive'} onClick={() => setAlertState(el?.key)}>
						{el?.value}
					</span>
				</li>
			))}
		</ul>
	);

	return (
		<>
			<ContentWrapper shadow>
				<h5>Please enter the Mail ID to share alerts</h5>
				{alertTabs}
				<div className='row'>
					<div className='col-6'>
						<Textarea placeholder='Eg: abc@gmail.com' value={createObj?.bfm_alerts[alertState]?.toString()} onChange={e => handleAlertsMail(e?.target?.value)} disabled={context.dockerState === 'view'} />
					</div>
				</div>
			</ContentWrapper>
		</>
	);
};

export default AlertMessage;
